export default "__VITE_ASSET__DEmK2yIC__"